const state = {
  locations: [],
  filtersForMap: {},
  centerPointForMap: [],
};

const mutations = {
  setLocations(state, locations) {
    state.locations = locations;
  },
  setFiltersForMap(state, filtersForMap) {
    state.filtersForMap = filtersForMap;
  },
  setCenterPointForMap(state, centerPointForMap) {
    state.centerPointForMap = centerPointForMap;
  },
};

const getters = {
  getLocations(state) {
    return state.locations;
  },
  getFiltersForMap(state) {
    return state.filtersForMap;
  },
  getCenterPointForMap(state) {
    return state.centerPointForMap;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  // actions
};
